export const store = createPinia()
